module.exports = __webpack_public_path__ + "img/upload.b0377b30.svg";